<template>
  <div class="w-full mx-auto top-0 min-w-0 min-h-0 overflow-hidden"
    v-if="user">
    <dashboard-heading :name="user.name" :photo="user.urlProfilePhoto" />
    <div class="flex min-h-screen flex-col md:flex-row">
      <section class="w-full px-3 lg:px-0 bg-white z-10 flex shadow min-h-screen">
        <div class="flex flex-col lg:pl-0 md:pl-4 w-full">
          <profile-nav :dashboardPath="dashboardPath" :profilePic="user.urlProfilePhoto" />
          <router-view></router-view>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import axios from 'axios';
import dayjs from 'dayjs';
import TimezoneForm from '@/components/TimezoneForm.vue';
import StreamFunctionsMixin from '@/mixins/StreamFunctionsMixin';
import DatesConversion from '@/mixins/DatesConversion';
import DashboardHeading from '../components/graphics/DashboardHeading.vue';
import ProfileNav from '../components/graphics/ProfileNav.vue';

export default {
  data() {
    return {
      bookedSlots: [],
    };
  },

  components: {
    DashboardHeading,
    ProfileNav,
  },

  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      user: 'auth/user',
      student: 'auth/student',
      dashboardPath: 'auth/dashboardPath',
    }),
    checkedBookedSlots() {
      return this.checkSlotsTimeToMakeButtonAppear(this.bookedSlots);
    },
    notificationsChannel() {
      return `App.Student.${this.student.id}`;
    },
    notifiableType() {
      return 'App\\Student';
    },
    notifiableId() {
      return this.student.id;
    },
  },

  watch: {
    choosenTimezone() {
      this.bookedSlots = [];
      if (this.user) {
        this.getBookedLessons();
      }
    },
  },

  created() {
    window.Echo.private(this.notificationsChannel)
      .notification((notification) => {
        this.addNotification({
          ...notification,
          notifiableId: this.notifiableId,
          notifiableType: this.notifiableType,
        });
      });
  },

  mounted() {
    if (this.user) this.getBookedLessons();
  },

  mixins: [StreamFunctionsMixin, DatesConversion],

  methods: {
    ...mapActions({
      addNotification: 'notifications/addFromPusher',
    }),
    chooseTimezone() {
      this.$modal.show(TimezoneForm, {}, {
        adaptive: true, resizable: true, height: 'auto',
      });
    },

    getBookedLessons() {
      const now = dayjs.utc();
      now.subtract(15, 'm');
      const startDate = this.changeDateFormatForCalendarAndDatabase(now);
      return axios.get(`/api/students/${this.user.student.id}/lessons?startDate=${startDate}`)
        .then((response) => {
          response.data.forEach((slot) => {
            if (slot.status === 'booked') {
              const newSlot = this.convertBookedSlotToBePrintedOnDashboard(slot, 'student');
              newSlot.lesson = slot.lesson;
              if (!this.bookedSlots.some(
                (existingSlot) => existingSlot.startDate === newSlot.startDate,
              )) {
                this.bookedSlots.push(newSlot);
              }
            }
          });
        }).catch((errors) => {
          console.log(`Lettura slots prenotati fallita: ${errors}`);
        });
    },

    payLesson(slot) {
      axios.post(`/api/lessons/${slot.booking_id}/payment`)
        .then((response) => {
          if (this.paymentMethod === 'paypal') {
            this.loadPaypal(response.data);
            return;
          }
          if (this.paymentMethod === 'card' && response.data.error) {
            this.checkTheErrorType(response.data, slot);
            return;
          }
          this.startLesson(slot);
        }).catch(() => {
          this.createNotification('error', `${this.$t('notifications.errorPayment')}`);
        });
    },

    startLesson(slot) {
      axios.get(`/api/lesson/${slot.booking_id}/get-url?for=student`).then(({ data }) => {
        window.location.href = data;
      }).catch((errors) => {
        console.log(errors);
      });
    },
  },
};
</script>

<style scoped lang="scss">
  .shadowColorMobile {
    --tw-shadow: 0 10px 15px 3px rgb(0, 0, 0),
      0 10px 6px 2px rgb(77, 71, 71);
      box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(235, 98, 98, 0)),
      var(--tw-ring-shadow, 0 0 rgba(243, 93, 93, 0)), var(--tw-shadow);
  }
  .shadowColor {
    --tw-shadow: 0 10px 10px -3px rgb(0, 0, 0),
      0 0px 6px -2px rgb(77, 71, 71);
      box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(235, 98, 98, 0)),
      var(--tw-ring-shadow, 0 0 rgba(243, 93, 93, 0)), var(--tw-shadow);
  }
  .tooltip {
    @apply invisible absolute text-gray-500 text-xs mt-10 font-sans-serif;
  }

  .has-tooltip:hover .tooltip {
    @apply visible z-50;
  }
</style>
